import React from "react";

const Tooltip = ({ text, children, className }) => {
  return (
    <div className={`relative group ${className}`}>
      {children}

      {/* le tooltip */}
      <div
        className="
          absolute left-1/2 -translate-x-1/2 mt-2
          hidden group-hover:block
          bg-gray-800 text-white text-sm leading-relaxed
          rounded shadow-lg z-10 px-4 py-3 whitespace-normal
        "
        style={{
          /* ↴  largeur mini 16 rem, idéale 50 vw, maxi 600 px
                 on reste < 90 vw pour ne jamais sortir de l’écran */
          width: "clamp(16rem, 50vw, 600px)",
          maxWidth: "90vw",
          /* empêche la largeur de tomber au‐dessous de max-content,
             ainsi le bloc s’élargit naturellement jusqu’à atteindre
             la “valeur clamp” sans casser les mots */
          boxSizing: "border-box",
        }}
      >
        {text}
      </div>
    </div>
  );
};

export { Tooltip };
